
// to save the address of the user.
export const SAVE_SHIPPING_INFO_REQUEST = 'SAVE_SHIPPING_INFO_REQUEST';
export const SAVE_SHIPPING_INFO_SUCCESS = 'SAVE_SHIPPING_INFO_SUCCESS';
export const SAVE_SHIPPING_INFO_FAILURE = 'SAVE_SHIPPING_INFO_FAILURE';
